import { useContext } from 'react'

import {
  Button,
  Columns,
  LoadingModule,
  SaveFormModule,
} from '@domain-group/suit-theme'

import useTrainingCourse, { useTrainingCourseForm } from '@hooks/useTrainingCourse'

import PageContext from '@contexts/pageContext'

import PageLayout from '../../../../components/PageLayout'
import TrainingCourseTools from '../../../../components/TrainingCourseTools'

import TrainingCourseDetails from '../TrainingCourseDetails'
import TrainingCourseImage from '../TrainingCourseImage'
import TrainingModules from '../TrainingModules'

const PageContent = (props: { trainingCourseId: number}) => {
  const { trainingCourseId } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      updateTrainingCourse,
    },
  } = pageContext

  const trainingCoursePayload = useTrainingCourse({ id: trainingCourseId })
  const {
    trainingCourse,
    callbacks: {
      updateTrainingCourse: updateFn,
    },
    loading,
    updating,
  } = trainingCoursePayload

  // @ts-expect-error TS2345
  const trainingCourseFormPayload = useTrainingCourseForm(trainingCourse, { validateOn: 'change' })
  const { entityState, saveEnabled } = trainingCourseFormPayload

  const updateTrainingCoursePayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    toastText: 'Training Course Updated',
  }

  return (
    <PageLayout entityPayload={trainingCoursePayload} activeTabBarItemKey="details">
      <Columns.Main>
        <LoadingModule loading={loading} times={3} />

        {!loading && (
          <>
            <TrainingCourseDetails trainingCourseFormPayload={trainingCourseFormPayload} />

            <TrainingModules trainingCourseId={trainingCourseId} />

            <SaveFormModule>
              <Button
                buttonStyle="primaryCreate"
                disabled={!saveEnabled}
                loading={updating}
                //@ts-expect-error
                marginLeft="auto"
                onClick={() => updateTrainingCourse(updateTrainingCoursePayload)}
                size="medium"
              >
                Save Details
              </Button>
            </SaveFormModule>
          </>
        )}
      </Columns.Main>

      <Columns.Sidebar>
        <TrainingCourseImage trainingCoursePayload={trainingCoursePayload} />

        <TrainingCourseTools trainingCoursePayload={trainingCoursePayload} />
      </Columns.Sidebar>
    </PageLayout>
  )
}

export default PageContent
